import React, { useEffect, useState } from "react";
import { Typography, Alert } from "@mui/material";
import TextInputBox from "../../components/TextInputBox";
import ButtonBox from "../../components/ButtonBox";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  ROUTE_DASHBOARD,
  TOKEN_ACCESS,
  TOKEN_SESSION,
  USER_EMAIL,
  USER_ID,
  USER_NAME,
  USER_ORG,
} from "../../constants";
import "../../style/Login.css";
import LoginApi from "../../api/LoginApi";
import { addLocalStorage, useLoading } from "../../utils/functions";

interface LoginProps {
  setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const Login: React.FC<LoginProps> = ({ setLoginPage }) => {
  const { startLoading, stopLoading } = useLoading();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const [formValues, setFormValues] = useState({
    organization: "",
    email: "",
    password: "",
  });


  const handleChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormValues((prevValues) => ({
        ...prevValues,
        [field]: e.target.value,
      }));
    };

  const handleLogin = async () => {
    startLoading();
    setError("");

    try {
      if (
        formValues.organization === "" ||
        formValues.email === "" ||
        formValues.password === ""
      ) {
        setError(
          "The organization name, email, or password you entered is incorrect."
        );
      } else {
        const loginResponse = await LoginApi.login(
          formValues.organization,
          formValues.email,
          formValues.password
        );

        if (loginResponse?.data.data.sessionToken) {
          addLocalStorage(
            TOKEN_SESSION,
            loginResponse.data.data.sessionToken
          );
        }

        const tokenResponse = await LoginApi.getToken(
          formValues.organization,
          formValues.email,
          formValues.password
        );

        if (tokenResponse && tokenResponse.access_token) {
          addLocalStorage(TOKEN_ACCESS, tokenResponse.access_token);
        }

        const meResponse = await LoginApi.getMe();
        if (meResponse) {
          addLocalStorage(USER_ID, meResponse.id);
          addLocalStorage(USER_NAME, meResponse.name);
          addLocalStorage(USER_EMAIL, meResponse.email);
        }

        const orgResponse = await LoginApi.getOrg();
        if (orgResponse) {
          addLocalStorage(USER_ORG, orgResponse.name);
        }

        window.dispatchEvent(new Event("storage"));

        navigate(ROUTE_DASHBOARD);
      }
    } catch (err: any) {
      setError("Login failed: " + err.message);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const handleEnter = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        handleLogin();
      }
    };

    document.addEventListener("keydown", handleEnter);
    return () => document.removeEventListener("keydown", handleEnter);
  }, []);

  return (
    <>
      <Typography className="login_typography_title">Login</Typography>

      {error && (
        <Alert
          severity="error"
          icon={<ErrorOutlineIcon />}
          className="login_error_alert"
        >
          {error}
        </Alert>
      )}

      <TextInputBox
        label="Organization name"
        value={formValues.organization}
        onChange={handleChange("organization")}
        placeholder="ORing"
      />

      <TextInputBox
        label="Email"
        value={formValues.email}
        onChange={handleChange("email")}
        placeholder="Please enter your email"
        type="email"
      />

      <TextInputBox
        label="Password"
        value={formValues.password}
        onChange={handleChange("password")}
        placeholder="Please enter your password"
        type="password"
      />

      <ButtonBox text="Login" onClick={handleLogin} />

      {/* <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
                <Link
                    href="#"
                    color="primary"
                    underline="none"
                    onClick={() => setLoginPage(LOGIN_FORGETPASSWORD)}
                >
                    Forget password?
                </Link>

                <Typography className='login_typography_content'>
                    Don't have an account?{' '}
                    <Link
                        href="#"
                        color="primary"
                        underline="none"
                        onClick={() => setLoginPage(LOGIN_SIGNUP)}
                    >
                        Sign up
                    </Link>
                </Typography>
            </Box> */}
    </>
  );
};

export default Login;
